import { requireNativeModule } from "expo-modules-core";
export interface GlyphTabIconImage {
  height: number;
  scale: number;
  uri: string;
  width: number;
}
/** One colored stretch of the icon text, e.g. a reading's pinyin in its tone color. */
export interface GlyphTabIconRun {
  color: string;
  text: string;
}
/** Render the icon text as an image so iOS glass preserves each tone color. */
export function renderGlyphTabIcon(
  runs: readonly GlyphTabIconRun[],
  fontFamily: string,
  fallbackFontFamily: string,
  fontSize: number,
  maxWidth: number,
): Promise<GlyphTabIconImage> {
  return requireNativeModule<{
    render(
      runs: readonly GlyphTabIconRun[],
      fontFamily: string,
      fallbackFontFamily: string,
      fontSize: number,
      maxWidth: number,
    ): Promise<GlyphTabIconImage>;
  }>("HaniverseGlyphTabIcon").render(runs, fontFamily, fallbackFontFamily, fontSize, maxWidth);
}
